import { config, executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils'
import { APIEndPoints } from './APIEndPoints'
import { getUrl } from './config'

const getRequestBody = (username: string, password: string) => {
  return {
    username: username,
    password: password,
  }
}

const responseParser = (response: any) => {
  const respData = isSuccessResponse(response)
  return {
    expireAt: respData?.expireAt?.toString(),
    token: respData?.token,
  }
}

const login = (username: string, password: string) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.login),
    method: 'POST',
    config: config.default,
    cache: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: {
      ...getRequestBody(username, password),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { login }
